module.exports = __webpack_public_path__ + "src/assets/textures/icons/minus.png";